import React, { useEffect } from 'react';
import '../index.css';

let viewportInitDone = false;
let viewportListenersAttached = false;
let viewportHandler = null;

const removePrefixedClasses = (element, prefix) => {
  if (!element) return;
  [...element.classList].forEach((className) => {
    if (className.startsWith(prefix)) {
      element.classList.remove(className);
    }
  });
};

const ViewportPreloader = ({ children }) => {
  useEffect(() => {
    const detectViewport = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const pixelRatio = window.devicePixelRatio || 1;
      let deviceType = 'desktop';
      if (width < 480) deviceType = 'small-mobile';
      else if (width < 768) deviceType = 'mobile';
      else if (width < 1024) deviceType = 'tablet';
      else if (width < 1440) deviceType = 'desktop';
      else deviceType = 'large-desktop';
      const zoomLevel = Math.min(pixelRatio, 1.5);

      // No borrar className completo: solo reemplazar clases propias de viewport.
      removePrefixedClasses(document.body, 'device-');
      removePrefixedClasses(document.body, 'zoom-');
      document.body.classList.add(`device-${deviceType}`);
      document.body.classList.add(
        `zoom-${zoomLevel >= 1.3 ? 'high' : zoomLevel > 1.1 ? 'medium' : 'normal'}`
      );

      const root = document.documentElement;
      switch (deviceType) {
        case 'small-mobile': root.style.fontSize = zoomLevel > 1 ? '13px' : '14px'; break;
        case 'mobile': root.style.fontSize = zoomLevel > 1 ? '14px' : '15px'; break;
        case 'tablet': root.style.fontSize = zoomLevel > 1 ? '15px' : '16px'; break;
        default: root.style.fontSize = '16px';
      }
    };

    // Aplicar solo una vez al inicio para evitar "ajustes" visuales al navegar.
    if (!viewportInitDone) {
      detectViewport();
      viewportInitDone = true;
    }

    // Listeners globales se adjuntan una sola vez.
    if (!viewportListenersAttached) {
      viewportHandler = detectViewport;
      window.addEventListener('resize', viewportHandler);
      window.addEventListener('orientationchange', viewportHandler);
      viewportListenersAttached = true;
    }

    return undefined;
  }, []);

  return children;
};

export default ViewportPreloader;
